import { PixelFieldProps } from '@/@types/attributeFields';
import { InputAdornment, TextField } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const PixelField: React.FC<PixelFieldProps> = ({
    name,
    value = '',
    onChange,
    placeholder,
    ...props
}) => {
    const { t } = useTranslation();
    const { register, resetField } = useFormContext();

    const suffix = 'px';
    const parsedValue = value.replace(suffix, '');

    useEffect(
        () => resetField(name, { defaultValue: parsedValue }),
        [parsedValue],
    );

    return (
        <TextField
            fullWidth
            size="small"
            {...register(name)}
            {...props}
            onChange={e => onChange(e, { suffix })}
            placeholder={placeholder.replace(suffix, '')}
            type="number"
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">{t(suffix)}</InputAdornment>
                ),
            }}
        />
    );
};

export default PixelField;
